import { z } from 'zod';
import { ComponentType } from '$lib/sanity/types';
import { SanityDocumentSchema } from '../sanity';
import { TextBlockSchema } from './Text';

export const VanityNumberSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.VanityNumber),
  size: z
    .union([z.literal('small'), z.literal('medium'), z.literal('large'), z.literal('xLarge')])
    .nullish()
    .transform((x) => x ?? 'large'),
  prefix: z.string().optional().nullable(),
  number: z.number(),
  unit: z.string().optional().nullable(),
  animated: z.boolean(),
  description: z.array(TextBlockSchema).optional().nullable()
});

export type VanityNumber = z.infer<typeof VanityNumberSchema>;
